module.exports = __webpack_public_path__ + "static/media/5095A.c011b752.jpg";